import React, { Component } from 'react';
import { Button, Input, Select, Icon,DatePicker } from 'antd';
import API_URL from '../../../../../common/url';
import ExportUtil from '../../../../../common/ExportUtil';
import SelectBa from '../../../components/SelectBa';
import moment from 'moment';
import SearchRetrieve from '../../../../common/SearchRetrieve.new.js';

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class Filter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expand: false,
        };
    }

    search = () => {
        this.props.search();
    }

    export = () => {
        const { searchParams } = this.props;
        const url = API_URL.home.exportCustomerCompany;
        ExportUtil.export({ ...searchParams }, null, url);
    }

    handleKeyPress = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        switch (key) {
            case 'customerCompany':
            case 'ba': {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                onChange(searchParams);
                break;
            }
            case 'customerBaName': {
                searchParams.customerBaNameIds = (value || []).map(i => i.id).join(',');
                searchParams.customerBaNameNames = (value || []).map(i => i.title).join(',');
                onChange(searchParams);
                break;
            }
            default:
                searchParams[key] = value;
                onChange(searchParams);
                break;
        }
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    render () {
        const { searchParams, businessList } = this.props;
        const { expand } = this.state;
        // let beginDateDefault = moment().format('YYYY-MM');
        // let endDateDefault = moment().format('YYYY-MM');
        const {
            // beginDate = beginDateDefault,
            // endDate = endDateDefault,
            beginDate = null,
            endDate = null,
        } = searchParams;
        const{curRole}=sessionStorage;

        return (
            <div style={{ marginBottom: 16 }}>
                <div className={`search-bar expand ${expand ? 'expanded' : ''}`}>
                <div className="search-item">
                        <div className="ui-label">客户付款单位</div>
                        <SearchRetrieve
                            keyword='customerCompanyName'
                            style={{ width: 160 }}
                            placeholder="输入客户付款单位检索"
                            value={searchParams.customerCompanyName}
                            params={{ limit: 20 }}
                            url={API_URL.investigation.queryCustomerCompanyByName}
                            config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                            onChange={(option) => this.handleChange(option, 'customerCompany')}
                        />
                    </div>
                   <div className="search-item">
                        <label htmlFor="" className="ui-label">时间</label>
                        <MonthPicker
                            format={monthFormat}
                            style={{width: 100}}
                            value={beginDate ? moment(beginDate) : null}
                            //disabledDate={this.disabledDate}
                            placeholder="选择月份"
                            onChange={(date, dateString) => this.handleChange(dateString, 'beginDate')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">至</label>
                        <MonthPicker
                            format={monthFormat}
                            style={{width: 100}}
                            value={endDate ? moment(endDate) : null}
                            placeholder="选择月份"
                            onChange={(date, dateString) => this.handleChange(dateString, 'endDate')}
                        />
                    </div>
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        <Button type="primary" onClick={this.export}>导出</Button>
                    </div>
                </div>
                {/* <div className="search-bar flex-end">
                  
                </div> */}
                <SelectBa ref={el => this.selectBaRef = el} onChange={list => this.handleChange(list, 'customerBaName')} />
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/ClientDataSearch/ClientDataSearchSheet/TablePage/Filter.js